import React from 'react';
    import Header from '../components/Header';
    import Footer from '../components/Footer';
    import { motion } from 'framer-motion';

    const TermsOfServicePage = () => {
      // SVG data URI for email protection
      const emailImage = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyODAiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyODAgMjQiIGZpbGw9Im5vbmUiPjx0ZXh0IHg9IjAiIHk9IjE4IiBmaWxsPSIjNEI1NTYzIiBmb250LWZhbWlseT0iSW50ZXIsIHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMTZweCI+ZGl2b3JjZXdpdGhkaXJlY3Rpb25AZ21haWwuY29tPC90ZXh0Pjwvc3ZnPg==";

      return (
        <div className="min-h-screen">
          <Header />
          <main className="pt-12">
            <section className="py-20 bg-sage-50">
              <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                <motion.h1 initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }} className="text-4xl md:text-5xl font-canela font-light text-gray-900 mb-6">
                  Terms of Service
                </motion.h1>
                <motion.p initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.2 }} className="text-xl text-gray-700 font-inter leading-relaxed">
                  Terms and conditions for our coaching services
                </motion.p>
              </div>
            </section>

            <section className="py-20 bg-white">
              <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }} className="prose prose-lg max-w-none">
                  <div className="space-y-8 text-gray-700 font-inter leading-relaxed">
                    <div>
                      <p className="text-sm text-gray-500 mb-8">Last updated: January 2025</p>
                    </div>
                    <div>
                      <h2 className="text-2xl font-canela font-medium text-gray-900 mb-4">Nature of Services</h2>
                      <p className="mt-4">
                        <strong>Important:</strong> Our coaching services are not a substitute for legal advice, therapy, or medical treatment.
                      </p>
                    </div>
                    <div>
                      <h2 className="text-2xl font-canela font-medium text-gray-900 mb-4">Contact Information</h2>
                      <p>If you have any questions about these Terms of Service, please contact us at:</p>
                      <div className="mt-4">
                        <img src={emailImage} alt="Contact Email" className="h-6 object-contain" />
                      </div>
                    </div>
                  </div>
                </motion.div>
              </div>
            </section>
          </main>
          <Footer />
        </div>
      );
    };

    export default TermsOfServicePage;